import { randomTitle, RandomGenerator } from '..';
var UserRoleBuilder = /** @class */ (function () {
    function UserRoleBuilder() {
        this.role = {
            id: 'b0bb0b0b-b0b0-b0b0-b0b0-b0bb0bb0bb0b',
            name: 'My Test Role',
            permissionsData: {},
            editable: false,
            creationDate: 10,
            lastUpdateDate: 20
        };
    }
    UserRoleBuilder.prototype.withId = function (id) {
        this.role.id = id;
        return this;
    };
    UserRoleBuilder.prototype.withName = function (name) {
        this.role.name = name;
        return this;
    };
    UserRoleBuilder.prototype.withDescription = function (description) {
        this.role.description = description;
        return this;
    };
    UserRoleBuilder.prototype.withCreationDate = function (creationDate) {
        this.role.creationDate = creationDate;
        return this;
    };
    UserRoleBuilder.prototype.withLastUpdateDataDate = function (lastUpdateDate) {
        this.role.lastUpdateDate = lastUpdateDate;
        return this;
    };
    UserRoleBuilder.prototype.withPermissionsData = function (permissionsData) {
        this.role.permissionsData = permissionsData;
        return this;
    };
    UserRoleBuilder.prototype.withEditable = function (editable) {
        this.role.editable = editable;
        return this;
    };
    UserRoleBuilder.prototype.build = function () {
        return this.role;
    };
    UserRoleBuilder.prototype.generateRandomList = function (num) {
        return randomTitle(num)
            .map(function (name) { return new UserRoleBuilder()
            .withName(name)
            .withId(RandomGenerator.randomId())
            .build(); });
    };
    return UserRoleBuilder;
}());
export { UserRoleBuilder };
//# sourceMappingURL=roles.builder.js.map